import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { ColorPicker, type SelectedColor } from "@/components/colors/ColorPicker";

export function ColorPickerDialog({
  open,
  onOpenChange,
  onSelect,
  surfaceLabel,
}: {
  open: boolean;
  onOpenChange: (v: boolean) => void;
  onSelect: (c: SelectedColor) => void;
  surfaceLabel: string;
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[min(1400px,96vw)] w-[96vw] h-[92vh] max-h-[92vh] overflow-hidden flex flex-col bg-[#0a0a0a] border-white/10 text-white p-6">
        <DialogHeader>
          <DialogTitle className="text-white">
            Choose a color for <span className="text-amber-300">{surfaceLabel}</span>
          </DialogTitle>
        </DialogHeader>
        <div className="flex-1 min-h-0 overflow-y-auto -mx-2 px-2">
          <ColorPicker
            onSelect={(c) => {
              onSelect(c);
              onOpenChange(false);
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}